import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'recompose';
import PermissionsFields from '../../../../../common/permissionsForm/permissions';
import withCanModifyBarber from './withCanModifyBarber';
import {
  withBarberEngagePermissionSettings,
} from '../../../../../../modules/shared/engage/permissions/with-barber-engage-permission-settings';

const Permissions = ({ canModify, showEngagePermissionForBarbers, disableEngagePermission }) => (
  <div className="u-mv">
    <fieldset disabled={!canModify}>
      <PermissionsFields
        showEngagePermissionForBarbers={showEngagePermissionForBarbers}
        disableEngagePermission={disableEngagePermission}
      />
    </fieldset>
  </div>
);

Permissions.propTypes = {
  canModify: PropTypes.bool.isRequired,
  showEngagePermissionForBarbers: PropTypes.bool,
  disableEngagePermission: PropTypes.bool,
};

Permissions.defaultProps = {
  showEngagePermissionForBarbers: false,
  disableEngagePermission: false,
};

export default compose(withCanModifyBarber, withBarberEngagePermissionSettings)(Permissions);
